export default __webpack_public_path__ + "static/嘉宾头像_柳锴-becc9bcbb7b9e77dd91138bdd6e6ff34.png";